import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal, Tooltip} from "antd";
import {t} from "i18next";
import {getImagePathWithTheme, isStringNullOrEmpty} from "../../utils";
import {ARRAY_LIBRARY_TYPES_LIBRARY, CHECK_ALL, IMPORT_FILE_MODE_IMPORTMODE, MENU_SEPARATOR} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import {updateProperty} from "@model/Property";

const DialogRelatedProperty = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [arrayLibraryTypes,setArrayLibraryTypes] = useState<any>([]);
    const mPropertyRef = useRef<any>(null);

    useEffect(() => {

    }, []);

    const onShowDialog = (property:any,callback:any)=>{
        const arrayLibrarys = ARRAY_LIBRARY_TYPES_LIBRARY();
        if (property.arrayRelatedType){
            for (let i=0;i<arrayLibrarys.length;i++){
                const item = arrayLibrarys[i];
                const exitTypes = property?.arrayRelatedType.find(p=>p.value == item.value);
                if (exitTypes){
                    item.isChecked = true;
                }
            }
        }
        //是否全选..
        const allCheckItem:any = arrayLibrarys.find(p=>p.value == CHECK_ALL);
        const arrayValidateMenu = arrayLibrarys.filter(p=>p.value != CHECK_ALL && p.value != MENU_SEPARATOR);
        allCheckItem.isChecked = arrayValidateMenu.filter(p=>p.isChecked).length == arrayValidateMenu.length;

        setArrayLibraryTypes(arrayLibrarys);

        mPropertyRef.current = property;
        setIsShowDialog(true);
    }

    /**
     * 条目点击----选中OR不选中
     * @param item
     */
    const onCheckItem = (item)=>{
        const arrayNew = [...arrayLibraryTypes];
        if (item.value == CHECK_ALL){
            arrayNew.forEach(p=>{
                p.isChecked = !item.isChecked;
            })
        }else{
            item.isChecked = !item.isChecked;
        }
        const allCheckItem = arrayNew.find(p=>p.value == CHECK_ALL);
        const arrayValidateMenu = arrayNew.filter(p=>p.value != CHECK_ALL && p.value != MENU_SEPARATOR);
        allCheckItem.isChecked = arrayValidateMenu.filter(p=>p.isChecked).length == arrayValidateMenu.length;
        setArrayLibraryTypes(arrayNew);
    }

    /**
     * 关联类型...
     */
    const onRelatedType = ()=>{
        const arrayChecked = arrayLibraryTypes.filter(p=>p.isChecked && p.value != CHECK_ALL && p.value != MENU_SEPARATOR);
        mPropertyRef.current.arrayRelatedType = arrayChecked;
        updateProperty(mPropertyRef.current).then(res=>{
            window.globalRefreshList('refresh_page_property_');
        });
    }

    return <Modal width={420} zIndex={2005}
                  afterClose={() => {
                      props.onCloseCallback();
                      onRelatedType();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }} bodyStyle={{margin:'0px -4px 0px 0px'}}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("SelectRelatedLibrary")}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <div key={'div-dialog-related-property'}
                 style={{maxHeight: '620px',}}>
                <>
                    {
                        arrayLibraryTypes.map(p =>
                            <>
                                {
                                    p.value == MENU_SEPARATOR &&
                                    <div key={p.value + p.ext} className={'line'}
                                         style={{margin: '8px -22px'}}></div>
                                }
                                {
                                    p.value !== MENU_SEPARATOR &&
                                    <div key={p.value} className={'dropdown-item'}
                                         onMouseEnter={() => {
                                             const arrayNewType = [...arrayLibraryTypes];
                                             arrayNewType.forEach(p => p.isHoverd = false);
                                             p.isHoverd = true;
                                             setArrayLibraryTypes(arrayNewType);
                                         }} onMouseLeave={() => {
                                        const arrayNewType = [...arrayLibraryTypes];
                                        arrayNewType.forEach(p => p.isHoverd = false);
                                        setArrayLibraryTypes(arrayNewType);
                                    }} onClick={(event) => {
                                        onCheckItem(p);
                                    }} style={{
                                        background: 'transparent',
                                        display: 'flex',
                                        alignItems: 'center',
                                        height:'36px'
                                    }}>
                                        <img className={'img-16'}
                                             style={{filter: 'none', marginLeft: '0px'}}
                                             src={getImagePathWithTheme(p.icon)}/>

                                        <span className={'span-single-line'} style={{
                                            paddingLeft: '12px',
                                            paddingRight: '12px',
                                            color: 'var(--text-color)'
                                        }}>{p.label}</span>

                                        <div className={'flex-row-vertical-center'}
                                             style={{marginLeft: 'auto'}}>
                                            {
                                                // p.isHoverd && p.value != CHECK_ALL &&
                                                // <Tooltip title={t("ShowOnlyThis")}
                                                //          arrow={false}>
                                                //     <img style={{marginLeft: 'auto'}}
                                                //          className={'img-16 no-filter mr-6'}
                                                //          src={getImagePathWithTheme('library_eye_this')}
                                                //          onClick={(e) => {
                                                //              e.stopPropagation();
                                                //              e.preventDefault();
                                                //
                                                //          }}/>
                                                // </Tooltip>
                                            }

                                            <Checkbox style={{
                                                marginLeft: '4px',
                                                marginRight: '0px',
                                                pointerEvents: 'none'
                                            }} checked={p.isChecked} onChange={(e) => {
                                                // onCheckedItemClicked(p,e.target.checked)
                                            }}></Checkbox>
                                        </div>

                                    </div>
                                }
                            </>
                        )
                    }
                </>
            </div>

            {/*<div className={'flex-center mt-32 mb-4'}>*/}
            {/*    <Button*/}
            {/*        style={{height: '34px', minWidth: '120px'}}*/}
            {/*        className='large-w-button button-border-gray-style font-size-14 font-family-medium'*/}
            {/*        onClick={() => {*/}
            {/*            setIsShowDialog(false);*/}
            {/*        }}>{t("Cancel")}</Button>*/}
            {/*    <Button*/}
            {/*        // disabled={isStringNullOrEmpty(selectFile)}*/}
            {/*        className='large-w-button button-solid-style font-size-14 font-family-medium'*/}
            {/*        type="primary"*/}
            {/*        onClick={async () => {*/}

            {/*        }}*/}
            {/*        style={{*/}
            {/*            marginLeft: '12px',*/}
            {/*            minWidth: '120px'*/}
            {/*        }}*/}
            {/*        htmlType={"submit"}>{t("Import")}</Button>*/}
            {/*</div>*/}
        </div>
    </Modal>
})

export default DialogRelatedProperty;